import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { forgetPassword } from '../../Redux/LoginRedux.js';

function ForgetPassword({ toggleForm }) {
  const dispatch = useDispatch();
  const [emailId, setEmailId] = useState('');
  const [otpSent, setOtpSent] = useState(false);

  const handleForgetPassword = async (e) => {
    e.preventDefault();
    try {
      if (emailId.trim() === '') {
        toast.error('EmailId is required.');
        return;
      }
      const data = { emailId: emailId };
      await dispatch(forgetPassword(data))
        .then(() => {
          toast.success('Password reset OTP sent to your email.');
          setOtpSent(true);
        })
        .catch((error) => {
          console.error('Error in OTP dispatch:', error);
        });
    } catch (error) {
      console.error('Unexpected error:', error);
      toast.error('An unexpected error occurred.');
    }
  };

  return (
    <div>
      <h5 className='text-center'>Forget Password</h5>
      <div style={{ padding: '25px' }}>
        {!otpSent ? (
          <form onSubmit={handleForgetPassword}>
            <div>
              <label htmlFor='forgetEmail'>
                Enter your registered email{' '}
                <span className='requiredAsterisk'>*</span>
              </label>
              <input
                type='email'
                id='forgetEmail'
                name='forgetEmail'
                className='form-control mb-3 mt-2'
                onChange={(e) => setEmailId(e.target.value)}
                style={{ border: '1px solid #cccccc' }}
                required
              />
            </div>
            <div className='row'>
              <div className='d-grid gap-2 col-8 mx-auto'>
                <button
                  className='btn'
                  style={{ background: '#2b6930', color: '#fff' }}
                  type='submit'
                >
                  Send Reset OTP
                </button>
              </div>
            </div>
          </form>
        ) : (
          <div>
            <p className='text-center'>
              Your password reset request has been sent successfully. Please
              check your email for the OTP. Use the OTP as your current password
              to log in and reset your password.
            </p>
          </div>
        )}
        <div className='row mt-4'>
          <div className='col-12 text-center'>
            <Button
              onClick={() => {
                setOtpSent(false);
                toggleForm('login');
              }}
              fullWidth
              color='success'
            >
              Back to Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
